import BookingInformationDetail from "@/containers/TourBookingByCustomerHome/TourBookingInfoDetail/BookingConfirm/BookingInformationDetail";
import { BookingTitle } from "@/containers/TourBookingByCustomerHome/TourBookingInfoDetail/BookingConfirm/style";
import { Box, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog"
import { useTranslation } from "react-i18next";
import { CloseIcon } from '@/components/SvgIcons';

interface TourBillDetailModalProps {
  open: boolean;
  onClose: () => void;
}

const TourBillDetailModal = ({ open, onClose }: TourBillDetailModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      disablePortal
      fullScreen={false}
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDialog-paper': { borderRadius: 2 } }}
    >
      <Box display={'flex'} flexDirection={'column'} sx={{ p: 2, overflow: 'scroll' }}>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          marginTop={1}
          marginBottom={4}
        >
          <BookingTitle align="center" sx={{ marginBottom: 0 }}>
            {t('bookingInfo')}
          </BookingTitle>
          <Box
            onClick={onClose}
            sx={{ cursor: 'pointer' }}
            alignItems={'start'}
          >
            <CloseIcon />
          </Box>
        </Box>

        <BookingInformationDetail key={'booking_info_modal'} haveBookingTitle={true} />
      </Box>
    </Dialog>
  )

}

export default TourBillDetailModal
